import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";

export default function Videoadmin() {
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [videos, setVideos] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // fetch videos
  const loadVideos = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allvideo.php");
    const data = await res.json();
    setVideos(data);
  };

const handleSelect = (video) => {
  setSelectedId(video.id);
  setTitle(video.title);
  setLink(video.link);
};

  useEffect(() => {
    loadVideos();
  }, []);

  // add video
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("link", link);

    await fetch("https://drpatangecitydentalclinic.com/api/addvideo.php", {
      method: "POST",
      body: formData,
    });

    setTitle("");
    setLink("");
    loadVideos();
  };

  // delete video
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Delete this video?");
    if (!confirmDelete) return;

    const formData = new FormData();
    formData.append("id", id);

    await fetch("https://drpatangecitydentalclinic.com/api/deletevideo.php", {
      method: "POST",
      body: formData,
    });

    loadVideos();
  };

  return (
    <div className="container-fluid p-4">
         <div className="row">

        <div className="col-md-3 col-lg-2 p-0">
          <Sidebar />
        </div>

                <div className="col-md-9 col-sm-12 col-lg-10 p-4">

      <h2 className="mb-4">Video Management</h2>

      {/* FORM */}
      <form onSubmit={handleSubmit} className="card p-3 mb-4 shadow">

        <input
          className="form-control mb-2"
          placeholder="Video Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <input
          className="form-control mb-2"
          placeholder="YouTube Link"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          required
        />

            <button className="btn btn-primary">
            {selectedId ? "Update Video" : "Add Video"}
            </button>
      </form>

      {/* TABLE */}
<div className="table-responsive">
  <table className="table table-bordered table-hover">
    <thead className="table-dark">
      <tr>
        <th>ID</th>
        <th>Title</th>
        <th>Video</th>
        <th>Actions</th>
      </tr>
    </thead>

    <tbody>
      {videos.map((v) => (
        <tr key={v.id}>
          <td>{v.id}</td>
          <td>{v.title}</td>

          <td style={{ minWidth: "200px" }}>
           {v.link}
          </td>

          <td style={{ minWidth: "180px" }}>
            <button
              className="btn btn-primary btn-sm me-2"
              onClick={() => handleSelect(v)}
            >
              Select
            </button>

            <button
              className="btn btn-danger btn-sm"
              onClick={() => handleDelete(v.id)}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
      </div>

    </div>
</div>
  );
}